<h2 mat-dialog-title style="text-align: center;">{{data.title}}</h2>
<mat-dialog-content class="mat-typography">
  <!--<h3 *ngIf="data.timeseries?.length == 0">{{data.content}} -> {{data.id}}</h3>-->
  <div *ngIf="data.wait" fxLayout="row" fxLayoutAlign="space-around center" style="text-align: center;">
    <mat-spinner [diameter]="75"></mat-spinner>
  </div>
  <div *ngIf="data.type== 0 && data.option == -1 && data.id == -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="addCampaignForm">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Tundish</mat-label>
            <input matInput [value]="data.disp" formControlName="tundishUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Campaña</mat-label>
            <input matInput [value]="data.name" formControlName="campaignName">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Inicio</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="campaignStartDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Finalización</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="campaignEndDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 2 && data.option == -1 && data.id == -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="addConsumptionForm">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Tundish</mat-label>
            <input matInput [value]="data.disp" formControlName="tundishUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Acero</mat-label>
            <input matInput formControlName="steelConsumption">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Número de Coladas</mat-label>
            <input matInput formControlName="steelCastings">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="consumptionTimestamp">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 0 && data.option == 0 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="editCampaignForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Identificador de Tundish</mat-label>
          <input matInput formControlName="tundishUuid">
        </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Campaña</mat-label>
            <input matInput formControlName="campaignUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Nombre de Campaña</mat-label>
            <input matInput formControlName="campaignName">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Inicio</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="campaignStartDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Finalización</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="campaignEndDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 2 && data.option == 0 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="editConsumptionForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Identificador de Tundish</mat-label>
          <input matInput formControlName="tundishUuid">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Consumo de Acero</mat-label>
          <input matInput formControlName="steelConsumption">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Número de Coladas</mat-label>
          <input matInput formControlName="steelCastings">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="consumptionTimestamp">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 1 && data.option == 8 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="editOperationForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Identificador de Tundish</mat-label>
          <mat-select formControlName="operationTundishUuid" (selectionChange)="doChangeTundishNumber(data.metadata.disps, $event, 0)">
            <mat-option *ngFor="let disp of data.metadata.disps" [value]="disp.uuid">{{disp.nombre}} ({{disp.uuid}})</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Número de Tundish</mat-label>
          <input matInput formControlName="operationTundishNumber">
        </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Operación</mat-label>
            <input matInput formControlName="operationUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Inicio</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="operationStartDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Finalización</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="operationEndDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Arena (Kgs)</mat-label>
            <input matInput formControlName="operationSandConsumption">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Silicato (Lts)</mat-label>
            <input matInput formControlName="operationSilicateConsumption">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Catalizador (Lts)</mat-label>
            <input matInput formControlName="operationCatalystConsumption">
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 1 && data.option == 9 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <form [formGroup]="editIntervalForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Identificador de Tundish</mat-label>
          <mat-select formControlName="intervalTundishUuid" (selectionChange)="doChangeTundishNumber(data.metadata.disps, $event, 1)">
            <mat-option *ngFor="let disp of data.metadata.disps" [value]="disp.uuid">{{disp.nombre}} ({{disp.uuid}})</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Número de Tundish</mat-label>
          <input matInput formControlName="intervalTundishNumber">
        </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Identificador de Operación</mat-label>
            <input matInput formControlName="intervalUuid">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Inicio</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="intervalStartDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Fecha de Finalización</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="intervalEndDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Arena (Kgs)</mat-label>
            <input matInput formControlName="intervalSandConsumption">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Silicato (Lts)</mat-label>
            <input matInput formControlName="intervalSilicateConsumption">
          </mat-form-field>
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Consumo de Catalizador (Lts)</mat-label>
            <input matInput formControlName="intervalCatalystConsumption">
          </mat-form-field>
      </form>
    </div>
  </div>
  <div *ngIf="data.type == 0 && data.option == 1 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      ¿Desea usted eliminar la Campaña <b>{{data.id}}</b>?<br/>
      <b>NOTA: Esta operación es irreversible</b>
    </div>
  </div>
  <div *ngIf="data.type == 2 && data.option == 1 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      ¿Desea usted eliminar la entrada de consumo <b>{{data.id}}</b>?<br/>
      <b>NOTA: Esta operación es irreversible</b>
    </div>
  </div>
  <div *ngIf="data.type == 0 && data.option == 4 && data.id != -1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <mat-grid-list cols="3" rowHeight="1:0.5">
        <mat-grid-tile>
          <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
            <mat-card-title style="padding: 10px 0 0px 20px;">KPI#1</mat-card-title>
            <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Arena)</mat-card-subtitle>
            <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{consumedSandQuantity/steelProductionQuantity}}</mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
            <mat-card-title style="padding: 10px 0 0px 20px;">KPI#2</mat-card-title>
            <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Silicato)</mat-card-subtitle>
            <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{consumedSilicateQuantity/steelProductionQuantity}}</mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
            <mat-card-title style="padding: 10px 0 0px 20px;">KPI#3</mat-card-title>
            <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Catalizador)</mat-card-subtitle>
            <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{consumedCatalystQuantity/steelProductionQuantity}}</mat-card-content>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
  <div *ngIf="data.option == 2 && data.type == 0" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <table mat-table [dataSource]="dataSourceAlarmsByCampaign" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Name Column -->
        <ng-container matColumnDef="alarma">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Alarma </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.alarma}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fecha </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fecha/1000000)}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsAlarmsByCampaign"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsAlarmsByCampaign;"></tr>
      </table>
      <mat-paginator #campaignAlarmsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
  <div *ngIf="data.option == 4 && data.type == 1" id=""> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <table mat-table [dataSource]="dataSourceAlarmsByOperation" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Name Column -->
        <ng-container matColumnDef="alarma">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Alarma </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.alarma}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fecha </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fecha/1000000)}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsAlarmsByOperation"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsAlarmsByOperation;"></tr>
      </table>
      <mat-paginator #operationAlarmsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
  <div *ngIf="data.option == 2 && data.type == 1">
    <div style="width: 45%; float: left; margin-right: 5px;">
      <mat-card style="background-color: #ededed;">
        <mat-card-title style="padding: 20px 0 0 20px;">Consigna Cantidad Arena</mat-card-title>
        <mat-card-subtitle style="padding: 0 0 0 20px;">[kg/min]</mat-card-subtitle>
        <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">72</mat-card-content>
      </mat-card>
    </div>
    <div style="width: 45%; float: left; margin-right: 5px;">
      <mat-card style="background-color: #ededed;">
        <mat-card-title  style="padding: 20px 0 0 20px;">Velocidad Motor Arena</mat-card-title>
        <mat-card-subtitle style="padding: 0 0 0 20px;">[Hz]]</mat-card-subtitle>
        <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{sandEngineVelocity}}</mat-card-content>
      </mat-card>
    </div>
    <div style="clear: both;"></div>
    <plotly-plot
      [data]="data.product_graph_data.data"
      [layout]="data.product_graph_data.layout"
      [useResizeHandler]="true">
    </plotly-plot>
    <!-- Intervals Table -->
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <span class="mat-dialog-title">Distribución de los Intervalos de Trabajo</span>
      <table mat-table [dataSource]="dataSourceIntervalsReportSandByOperation" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Name Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="inicio">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="fin">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="cantidad">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Cantidad </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.arena.kilos)}} kgs</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsIntervalsReportSandByOperation"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsIntervalsReportSandByOperation;"></tr>
      </table>
      <mat-paginator #operationIntervalsReportSandPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
  <div *ngIf="data.option == 3 && data.type == 1">
    <div style="width: 45%; float: left; margin-right: 5px;">
      <mat-card style="background-color: #ededed;">
        <mat-card-title style="padding: 20px 0 0 20px;">Consigna Cantidad Silicato</mat-card-title>
        <mat-card-subtitle style="padding: 0 0 0 20px;">[l/min]</mat-card-subtitle>
        <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">3.2</mat-card-content>
      </mat-card>
    </div>
    <div style="width: 45%; float: left; margin-right: 5px;">
      <mat-card style="background-color: #ededed;">
        <mat-card-title  style="padding: 20px 0 0 20px;">Velocidad Motor Silicato</mat-card-title>
        <mat-card-subtitle style="padding: 0 0 0 20px;">[l/min]</mat-card-subtitle>
        <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{silicateEngineVelocity}}</mat-card-content>
      </mat-card>
    </div>
    <div style="clear: both;"></div>
    <plotly-plot
      [data]="data.product_graph_data.data"
      [layout]="data.product_graph_data.layout"
      [useResizeHandler]="true">
    </plotly-plot>
    <!-- Intervals Table -->
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <span class="mat-dialog-title">Distribución de los Intervalos de Trabajo</span>
      <table mat-table [dataSource]="dataSourceIntervalsReportSilicateByOperation" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Name Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="inicio">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="fin">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="cantidad">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Cantidad </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.silicato.litros)}} lts</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsIntervalsReportSilicateByOperation"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsIntervalsReportSilicateByOperation;"></tr>
      </table>
      <mat-paginator #operationIntervalsReportSilicatePaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
  <!-- Report: Operation -->
  <div *ngIf="data.option == 5 && data.type == 1" id="of_report"> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <div style="width: 100%; border-bottom: 1px solid #ededed;" id="report_header">
        <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Datos</div>
        <div id="report_logo" style="float: left; width: 30%; padding: 5px;">
          <img src="/assets/images/logo-magna.png" style="width: 92%;"/>
        </div>
        <div style="float: left; width: 35%; padding: 5px;">
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">UUID</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.uuid}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Inicio</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doTransformDate(data.report.start*1000)}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Fin</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doTransformDate(data.report.end*1000)}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Duración</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.duration}}</div>
        </div>
        <div style="float: left; width: 35%; padding: 5px;">
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Arena</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doRoundNumber(data.report.sand)}} kgs</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Silicato</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doRoundNumber(data.report.silicate)}} lts</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Catalizador</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doRoundNumber(data.report.catalyst)}} lts</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Alarmas</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.alarms.length}}</div>
        </div>
        <div style="clear: both; height: 1px;"></div>
      </div>
      <div>
        <div>
          <div id="report_graph_sand">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Arena</div>
            <div style="width: 49%; float: left; margin-right: 17px; margin-top: 5px;">
              <mat-card style="background-color: #ededed;">
                <mat-card-title style="padding: 10px 0 0 20px;">Consigna Cantidad Arena</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px;">[kg/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 10px 20px;">72</mat-card-content>
              </mat-card>
            </div>
            <div style="width: 49%; float: left; margin-top: 5px;">
              <mat-card style="background-color: #ededed;">
                <mat-card-title  style="padding: 10px 0 0 20px;">Velocidad Motor Arena</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px;">[Hz]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 10px 20px;">{{sandEngineVelocity}}</mat-card-content>
              </mat-card>
            </div>
            <div style="clear: both;"></div>
            <plotly-plot
              [data]="data.product_graph_data_sand.data"
              [layout]="data.product_graph_data_sand.layout"
              [useResizeHandler]="true">
            </plotly-plot>
            <!-- Intervals Table -->
            <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
              <span class="mat-dialog-title">Distribución de los Intervalos de Trabajo</span>
              <table mat-table [dataSource]="dataSourceIntervalsReportSandByOperation" class="mat-elevation-z8">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <!-- Name Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="inicio">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="fin">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="cantidad">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Cantidad </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.arena.kilos)}} kgs</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsIntervalsReportSandByOperation"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsIntervalsReportSandByOperation;"></tr>
              </table>
              <mat-paginator #operationIntervalsReportSandPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
          <div id="report_graph_silicate">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Silicato</div>
            <div style="width: 49%; float: left; margin-right: 17px; margin-top: 5px;">
              <mat-card style="background-color: #ededed;">
                <mat-card-title style="padding: 10px 0 0 20px;">Consigna Cantidad Silicato</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px;">[l/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 10px 20px;">3.2</mat-card-content>
              </mat-card>
            </div>
            <div style="width: 49%; float: left; margin-top: 5px;">
              <mat-card style="background-color: #ededed;">
                <mat-card-title  style="padding: 10px 0 0 20px;">Velocidad Motor Silicato</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px;">[l/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 10px 20px;">{{silicateEngineVelocity}}</mat-card-content>
              </mat-card>
            </div>
            <div style="clear: both;"></div>
            <plotly-plot
              [data]="data.product_graph_data_silicate.data"
              [layout]="data.product_graph_data_silicate.layout"
              [useResizeHandler]="true">
            </plotly-plot>
            <!-- Intervals Table -->
            <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
              <span class="mat-dialog-title">Distribución de los Intervalos de Trabajo</span>
              <table mat-table [dataSource]="dataSourceIntervalsReportSilicateByOperation" class="mat-elevation-z8">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <!-- Name Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="inicio">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="fin">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="cantidad">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Cantidad </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.silicato.litros)}} lts</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsIntervalsReportSilicateByOperation"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsIntervalsReportSilicateByOperation;"></tr>
              </table>
              <mat-paginator #operationIntervalsReportSilicatePaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
          <div id="report_graph_catalyst">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Catalizador</div>
            <div style="width: 49%; float: left; margin-right: 17px; margin-top: 5px;">
              <mat-card style="background-color: #ededed;">
                <mat-card-title style="padding: 10px 0 0 20px;">Consigna Cantidad Catalizador</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px;">[l/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 10px 20px;">0.4</mat-card-content>
              </mat-card>
            </div>
            <div style="width: 49%; float: left; margin-top: 5px;">
              <mat-card style="background-color: #ededed;">
                <mat-card-title  style="padding: 10px 0 0 20px;">Velocidad Motor Catalizador</mat-card-title>
                <mat-card-subtitle style="padding: 0 0 0 20px;">[l/min]</mat-card-subtitle>
                <mat-card-content style="font-size: 30px; padding: 0 0 10px 20px;">{{catalystEngineVelocity}}</mat-card-content>
              </mat-card>
            </div>
            <div style="clear: both;"></div>
            <plotly-plot
              [data]="data.product_graph_data_catalyst.data"
              [layout]="data.product_graph_data_catalyst.layout"
              [useResizeHandler]="true">
            </plotly-plot>
            <!-- Intervals Table -->
            <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
              <span class="mat-dialog-title">Distribución de los Intervalos de Trabajo</span>
              <table mat-table [dataSource]="dataSourceIntervalsReportCatalystByOperation" class="mat-elevation-z8">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <!-- Name Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="inicio">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="fin">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="cantidad">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Cantidad </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.catalizador.litros)}} lts</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsIntervalsReportCatalystByOperation"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsIntervalsReportCatalystByOperation;"></tr>
              </table>
              <mat-paginator #operationIntervalsReportCatalystPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
          <div id="report_alarms">
            <div *ngIf="data.report.alarms !== undefined && data.report.alarms.length > 0">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas</div>
              <div style="padding: 5px;">
                <div style="width: 10%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">#</div>
                <div style="width: 45%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">Alarma</div>
                <div style="width: 45%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">Fecha</div>
                <div *ngFor="let item of data.report.alarms; index as i">
                  <div style="width: 10%; padding: 5px; float: left; text-align: center">{{i+1}}</div>
                  <div style="width: 45%; padding: 5px; float: left; text-align: center;">{{item.alarma}}</div>
                  <div style="width: 45%; padding: 5px; float: left; text-align: center;">{{doTransformDate(item.fecha/1000000)}}</div>
                </div>
                <div style="clear: both; height: 1px"></div>
                <plotly-plot
                  [data]="data.pie_data.data"
                  [layout]="data.pie_data.layout"
                  [useResizeHandler]="true">
                </plotly-plot>
              </div>
            </div>
            <div *ngIf="data.report.alarms !== undefined && data.report.alarms.length == 0">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas</div>
              <div style="padding: 5px;">
                <p>No hay alarmas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div style="width: 100%; border-top: 1px solid #ededed; text-align: right; padding: 10px;" id="report_footer">
        {{data.date}}
      </div>
      -->
    </div>
  </div>
  <!-- Report: Campaign-->
  <div *ngIf="data.option == 3 && data.type == 0" id="of_report_campaign"> 
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <div style="width: 100%; border-bottom: 1px solid #ededed;" id="report_header">
        <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Datos</div>
        <div id="report_logo" style="float: left; width: 30%; padding: 5px;">
          <img src="/assets/images/logo-magna.png" style="width: 92%;"/>
        </div>
        <div style="float: left; width: 35%; padding: 5px;">
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">UUID</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.uuid}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Inicio</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doTransformDate(data.report.start*1000)}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Fin</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{doTransformDate(data.report.end*1000)}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Duración</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.duration}}</div>
        </div>
        <div style="float: left; width: 35%; padding: 5px;">
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">ID</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.id}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Operaciones</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.operations}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Intervalos</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.intervals}}</div>
          <div style="width: 30%; float: left; text-align: center; padding: 5px; background-color: #ededed; border-bottom: 1px solid #ededed;">Alarmas</div>
          <div style="width: 70%; float: left; text-align: center; padding: 5px; border-bottom: 1px solid #ededed;">{{data.report.alarms.length}}</div>
        </div>
        <div style="clear: both; height: 1px;"></div>
      </div>
      <div>
        <div>
          <div id="report_graph_operations">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Operaciones (Listado)</div>
            <!-- Intervals Table -->
            <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
              <table mat-table [dataSource]="dataSourceOperationsByCampaign" class="mat-elevation-z8">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <!-- Name Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="inicio">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="fin">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="duracion">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Duración </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.fin - element.inicio}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="arena">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Arena </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.campos.arena.kilos}} kgs</td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="silicato">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Silicato </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.campos.silicato.litros}} lts</td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="catalizador">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Catalizador </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.campos.catalizador.litros}} lts</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsOperationsByCampaign"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsOperationsByCampaign;"></tr>
              </table>
              <mat-paginator #operationsCampaignPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
          <div id="report_graph_operations_chart">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Operaciones (Gráfica)</div>
            <!-- Intervals Gantt Chart -->
            <plotly-plot
              [data]="data.operations_chart_data.data"
              [layout]="data.operations_chart_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
          </div>
          <div id="report_graph_intervals">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Intervalos (Listado)</div>
            <!-- Intervals Table -->
            <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
              <table mat-table [dataSource]="dataSourceIntervalsByCampaign" class="mat-elevation-z8">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <!-- Name Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="inicio">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="fin">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="duracion">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Duración </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.fin - element.inicio}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="arena">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Arena </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.campos.arena.kilos}} kgs</td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="silicato">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Silicato </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.campos.silicato.litros}} lts</td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="catalizador">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Catalizador </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.campos.catalizador.litros}} lts</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsIntervalsByCampaign"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsIntervalsByCampaign;"></tr>
              </table>
              <mat-paginator #intervalsCampaignPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
          <div id="report_graph_intervals_chart">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Intervalos (Gráfica)</div>
            <!-- Intervals Gantt Chart -->
            <plotly-plot
              [data]="data.intervals_chart_data.data"
              [layout]="data.intervals_chart_data.layout"
              [useResizeHandler]="true">
            </plotly-plot>
          </div>
          <div id="report_kpis">
            <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">KPIs</div>
            <div style="padding: 5px;">
              <mat-grid-list cols="3" rowHeight="1:0.5">
                <mat-grid-tile>
                  <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
                    <mat-card-title style="padding: 10px 0 0px 20px;">KPI#1</mat-card-title>
                    <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Arena)</mat-card-subtitle>
                    <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedSandQuantity/steelProductionQuantity)}}</mat-card-content>
                  </mat-card>
                </mat-grid-tile>
                <mat-grid-tile>
                  <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
                    <mat-card-title style="padding: 10px 0 0px 20px;">KPI#2</mat-card-title>
                    <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Silicato)</mat-card-subtitle>
                    <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedSilicateQuantity/steelProductionQuantity)}}</mat-card-content>
                  </mat-card>
                </mat-grid-tile>
                <mat-grid-tile>
                  <mat-card style="background-color: #ededed; margin: 10px; width: 100%;">
                    <mat-card-title style="padding: 10px 0 0px 20px;">KPI#3</mat-card-title>
                    <mat-card-subtitle style="padding: 0px 0 0px 20px;">Consumo Real Específico (Catalizador)</mat-card-subtitle>
                    <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{doRoundNumber(consumedCatalystQuantity/steelProductionQuantity)}}</mat-card-content>
                  </mat-card>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
          </div>
          <div id="report_alarms">
            <div *ngIf="data.report.alarms !== undefined && data.report.alarms.length > 0">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas (Listado)</div>
              <div style="padding: 5px;">
                <div style="width: 10%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">#</div>
                <div style="width: 45%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">Alarma</div>
                <div style="width: 45%; padding: 5px; float: left; text-align: center; background-color: #ededed; border-bottom: 1px solid #ededed;">Fecha</div>
                <div *ngFor="let item of data.report.alarms; index as i">
                  <div style="width: 10%; padding: 5px; float: left; text-align: center">{{i+1}}</div>
                  <div style="width: 45%; padding: 5px; float: left; text-align: center;">{{item.alarma}}</div>
                  <div style="width: 45%; padding: 5px; float: left; text-align: center;">{{doTransformDate(item.fecha/1000000)}}</div>
                </div>
                <div style="clear: both; height: 5px;"></div>
                <div id="report_alarms_chart">
                  <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas (Gráfica)</div>
                  <plotly-plot
                    [data]="data.pie_data.data"
                    [layout]="data.pie_data.layout"
                    [useResizeHandler]="true">
                  </plotly-plot>
                </div>
              </div>
            </div>
            <div *ngIf="data.report.alarms !== undefined && data.report.alarms.length == 0">
              <div style="background-color: #c0c0c0; width: 100%; text-align: center; padding: 5px;">Alarmas (Listado)</div>
              <div style="padding: 5px;">
                <p>No hay alarmas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div style="width: 100%; border-top: 1px solid #ededed; text-align: right; padding: 10px;" id="report_footer">
        {{data.date}}
      </div>
      -->
    </div>
  </div>
  <div *ngIf="data.option == 6 && data.type == 1">
    <div style="width: 45%; float: left; margin-right: 5px;">
      <mat-card style="background-color: #ededed;">
        <mat-card-title style="padding: 20px 0 0 20px;">Consigna Cantidad Catalizador</mat-card-title>
        <mat-card-subtitle style="padding: 0 0 0 20px;">[l/min]</mat-card-subtitle>
        <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">0.4</mat-card-content>
      </mat-card>
    </div>
    <div style="width: 45%; float: left; margin-right: 5px;">
      <mat-card style="background-color: #ededed;">
        <mat-card-title  style="padding: 20px 0 0 20px;">Velocidad Motor Catalizador</mat-card-title>
        <mat-card-subtitle style="padding: 0 0 0 20px;">[l/min]</mat-card-subtitle>
        <mat-card-content style="font-size: 30px; padding: 0 0 20px 20px;">{{catalystEngineVelocity}}</mat-card-content>
      </mat-card>
    </div>
    <div style="clear: both;"></div>
    <plotly-plot
      [data]="data.product_graph_data.data"
      [layout]="data.product_graph_data.layout"
      [useResizeHandler]="true">
    </plotly-plot>
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <span class="mat-dialog-title">Distribución de los Intervalos de Trabajo</span>
      <table mat-table [dataSource]="dataSourceIntervalsReportCatalystByOperation" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Name Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="inicio">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="fin">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="cantidad">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Cantidad </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.catalizador.litros)}} lts</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsIntervalsReportCatalystByOperation"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsIntervalsReportCatalystByOperation;"></tr>
      </table>
      <mat-paginator #operationIntervalsReportCatalystPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
  <div *ngIf="data.option == 7 && data.type == 1">
    <!-- Intervals Table -->
    <div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
      <table mat-table [dataSource]="dataSourceIntervalsByOperation" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Name Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UUID </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element._id}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="inicio">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.inicio*1000)}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="fin">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Fin </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doTransformDate(element.fin*1000)}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="duracion">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Duracion </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.fin - element.inicio}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="arena">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Arena </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.arena.kilos)}} kgs</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="silicato">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Silicato </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.silicato.litros)}} lts</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="catalizador">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Catalizador </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{doRoundNumber(element.campos.catalizador.litros)}} lts</td>
        </ng-container>

        <ng-container matColumnDef="tundish">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Tundish </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.disp}} (Tundish {{element.campos.tundish}})</td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Acciones </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> 
            <button *ngIf="element.fin != 0" mat-raised-button (click)="doAssignInterval(element._id, 9, 1, data.disps)" color="accent" style="margin: 5px 2px;" [disabled]="!data.admin">Reasignar</button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsIntervalsByOperation"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsIntervalsByOperation;"></tr>
      </table>
      <mat-paginator #operationIntervalsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.type == 0 && data.option == -1 && data.id == -1" mat-raised-button color="primary" (click)="doAddCampaign()">Añadir</button>
  <button *ngIf="data.type == 0 && data.option == 0" mat-raised-button color="primary" (click)="doEditCampaign(data.disp, data.id)">Editar</button>
  <button *ngIf="data.type == 0 && data.option == 1" mat-raised-button color="primary" (click)="doRemoveCampaign(data.disp, data.id)">Eliminar</button>
  <button *ngIf="data.type == 1 && data.option == 8" mat-raised-button color="primary" (click)="doEditOperation(data.metadata.disp, data.id)">Editar</button>
  <button *ngIf="data.type == 1 && data.option == 9" mat-raised-button color="primary" (click)="doEditInterval(data.metadata.disp, data.id)">Editar</button>
  <button *ngIf="data.type == 2 && data.option == -1 && data.id == -1" mat-raised-button color="primary" (click)="doAddConsumption()">Añadir</button>
  <button *ngIf="data.type == 2 && data.option == 0" mat-raised-button color="primary" (click)="doEditConsumption(data.disp, data.id)">Editar</button>
  <button *ngIf="data.type == 2 && data.option == 1" mat-raised-button color="primary" (click)="doRemoveConsumption(data.disp, data.id)">Eliminar</button>
  <button *ngIf="data.option == 5 && data.type == 1" mat-raised-button color="primary" (click)="doPrintOperationReport()" [disabled]="!isPrintEnabled">Imprimir</button>
  <button *ngIf="data.option == 3 && data.type == 0" mat-raised-button color="primary" (click)="doPrintCampaignReport()" [disabled]="!isPrintEnabled">Imprimir</button>
  <button *ngIf="!data.wait" mat-raised-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>